import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./StatusToggle.scss";

interface StatusToggleProps {
  isActive: boolean;
  onToggle: (newStatus: boolean) => void;
}

const StatusToggle: React.FC<StatusToggleProps> = ({ isActive, onToggle }) => {
  const tooltipTitle = isActive
    ? "Click to deactivate this service"
    : "Click to activate this service";

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span onClick={(e) => e.stopPropagation()}>
        <label className="status-toggle">
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => onToggle(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
          />
          <span className="slider" />
          {/* <span className="label-text">{isActive ? "Active" : "Inactive"}</span> */}
        </label>
      </span>
    </Tooltip>
  );
};

export default StatusToggle;
